module.exports = __webpack_public_path__ + "static/media/renewDateIcon.2879a290.svg";